export enum FeatureFlagKey {
  CAN_ACCESS_ADVISOR_ADMIN_ANALYTICS = 'can_access_advisor_admin_analytics',
  CAN_ACCESS_ADVISOR_PRO = 'can_access_advisor_pro',
  CAN_ACCESS_BILLING = 'can_access_billing',
  CAN_ACCESS_BILLING_SANDBOX = 'can_access_billing_sandbox',
  CAN_ACCESS_CASHFLOWS_V2 = 'can_access_cashflows_v2',
  CAN_ACCESS_CLEAR_WILL_BILLING = 'can_access_clear_will_billing',
  CAN_ACCESS_CLEAR_WILL_DASHBOARD_PAGE = 'can_access_clear_will_dashboard_page',
  CAN_ACCESS_CLEAR_WILL_ESTATE_ACCOUNTING_PAGE = 'can_access_clear_will_estate_accounting_page',
  CAN_ACCESS_CLEAR_WILL_INBOX_PAGE = 'can_access_clear_will_inbox_page',
  CAN_ACCESS_CLEAR_WILL_FILE_MANAGEMENT_PAGE = 'can_access_clear_will_file_management_page',
  CAN_ACCESS_CLEAR_WILL_POAS = 'can_access_clear_will_poas',
  CAN_ACCESS_MAINTENANCE_PAGE = 'can_access_maintenance_page',
  CAN_ACCESS_CONTACTS_PAGE = 'can_access_contacts_page',
  CAN_ACCESS_DEFINE_YOUR_SITUATION_STAGE = 'can_access_define_your_situation_stage',
  CAN_ACCESS_DETECT_AUTH_SESSION_MISMATCH = 'can_access_detect_auth_session_mismatch',
  CAN_VIEW_DISTRIBUTION_NO_LONGER_AVAILABLE = 'can_view_distribution_no_longer_available',
  CAN_ACCESS_DOCU_SIGN = 'can_access_docu_sign',
  CAN_ACCESS_ESTATE_DEMO_TEMPLATE_CREATION = 'can_access_estate_demo_template_creation',
  CAN_ACCESS_ESTATE_DISTRIBUTION = 'can_access_estate_distribution',
  CAN_ACCESS_ESTATE_RAG = 'can_access_estate_rag',
  CAN_ACCESS_ESTATE_SELECTION = 'can_access_estate_selection',
  CAN_ACCESS_FLINKS = 'can_access_flinks',
  CAN_ACCESS_FLINKS_INVESTMENT = 'can_access_flinks_investment',
  CAN_ACCESS_FLINKS_SANDBOX = 'can_access_flinks_sandbox',
  CAN_ACCESS_FUNERAL_ARRANGEMENT_STAGE_V2 = 'can_access_funeral_arrangement_stage_v2',
  CAN_ACCESS_INBOX_IMPERSONATION = 'can_access_inbox_impersonation',
  CAN_ACCESS_INLINE_CALENDLY_SCRIPT = 'can_access_inline_calendly_script',
  CAN_ACCESS_INBOX = 'can_access_inbox',
  CAN_ACCESS_INBOX_VIDEO = 'can_access_inbox_video',
  CAN_ACCESS_INBOX_V2 = 'can_access_inbox_v2',
  CAN_ACCESS_LARAVEL_OCTANE = 'can_access_laravel_octane',
  CAN_ACCESS_REDIS_SESSION_INVALIDATION = 'can_access_redis_session_invalidation',
  CAN_ACCESS_LIDAAP_ONBOARDING = 'can_access_lidaap_onboarding',
  CAN_ACCESS_LIDAAP_STANDALONE = 'can_access_lidaap_standalone',
  CAN_ACCESS_INTERIM_DISTRIBUTION_STAGE = 'can_access_interim_distribution_stage',
  CAN_ACCESS_MEMBERS_PAGE = 'can_access_members_page',
  CAN_ACCESS_NEEDS_NOTIFY_CREDITORS_UPSELL = 'can_access_needs_notify_creditors_upsell',
  CAN_ACCESS_NEEDS_WILL_SEARCH_UPSELL = 'can_access_needs_will_search_upsell',
  CAN_ACCESS_NOTIFY_CREDITOR_STEPS_IN_USA = 'can_access_notify_creditor_steps_in_usa',
  CAN_ACCESS_NOTIFY_CREDITORS_NEW_ESTATE_FORMS = 'can_access_notify_creditors_new_estate_forms',
  CAN_ACCESS_PLAID = 'can_access_plaid',
  CAN_ACCESS_PLAID_SANDBOX = 'can_access_plaid_sandbox',
  CAN_ACCESS_PLANNING_ONBOARDING_REDESIGN = 'can_access_planning_onboarding_redesign',
  CAN_ASSIGN_PROFESSIONAL_EXECUTOR = 'can_assign_professional_executor',
  CAN_ACCESS_GUIDES = 'can_access_guides',
  CAN_ACCESS_HEADLESS_CALENDLY_BOOKING = 'can_access_headless_calendly_booking',
  CAN_ACCESS_MEETINGS = 'can_access_meetings',
  CAN_HIDE_COMPLETE_CONTACT_INFO = 'can_hide_complete_contact_info',
  CAN_ACCESS_MICRO_TIP = 'can_access_micro_tip',
  CAN_SHOW_UNSAVED_CHANGES_WARNING_MODAL = 'can_show_unsaved_changes_warning_modal',
  CAN_ACCESS_NLP_PARSE_DRIVERS_LICENSE = 'can_access_nlp_parse_drivers_license',
  CAN_ACCESS_NOTIFICATION_CENTER = 'can_access_notification_center',
  CAN_ACCESS_QUEBEC_DISTRIBUTION = 'can_access_quebec_distribution',
  CAN_ACCESS_HELP_CENTER = 'can_access_help_center',
  CAN_ACCESS_SELF_SERVE_FLOW = 'can_access_self_serve_flow',
  CAN_ACCESS_TAXES = 'can_access_taxes',
  CAN_ACCESS_TEAMS_SESSION = 'can_access_teams_session',
  CAN_ACCESS_UPLIFT = 'can_access_uplift',
  CAN_ACCESS_UPDATED_REFERRALS_TABLE_UI = 'can_access_updated_referrals_table_ui',
  CAN_ACCESS_US_FINALIZE_INVENTORY_VALUE_STAGE = 'can_access_us_finalize_inventory_value_stage',
  CAN_ACCESS_USA_PROBATE_DOCUSIGN_STEPS = 'can_access_usa_probate_docusign_steps',
  CAN_ACCESS_USA_PROBATE_STAGE_STEPS = 'can_access_usa_probate_stage_steps',
  CAN_ACCESS_WELCOME_FLOW = 'can_access_welcome_flow',
  CAN_ACCESS_WILL_POA_STAGE_IN_CANADA = 'can_access_will_poa_stage_in_canada',
  CAN_ACCESS_WILL_POA_STAGE_IN_USA = 'can_access_will_poa_stage_in_usa',
  CAN_ACCESS_WILL_STEPS = 'can_access_will_steps',
  CAN_ACCESS_POA_INSTRUCTION_IMPROVEMENTS = 'can_access_poa_instruction_improvements',
  CAN_ACCESS_POA_STEPS = 'can_access_poa_steps',
  CAN_ACCESS_PROBATE_DETERMINATION_STAGE = 'can_access_probate_determination_stage',
  CAN_ACCESS_PROBATE_FORMS_FOR_BRITISH_COLUMBIA = 'can_access_probate_forms_for_british_columbia',
  CAN_ACCESS_PROBATE_FORMS_FOR_MANITOBA = 'can_access_probate_forms_for_manitoba',
  CAN_ACCESS_PROBATE_FORMS_FOR_SASKATCHEWAN = 'can_access_probate_forms_for_saskatchewan',
  CAN_ACCOUNTANT_ACCESS_STEP_ENGINE = 'can_accountant_access_step_engine',
  CAN_AUTO_PLAY_GUIDES = 'can_auto_play_guides',
  CAN_BOT_SEND_INBOX_TO_ESTATE_PROFESSIONAL_WHEN_UPLOADED_DOCUMENT = 'can_bot_send_inbox_to_estate_professional_when_uploaded_document',
  CAN_BOT_SEND_INBOX_TO_ACCOUNTANT_WHEN_UPLOADED_DOCUMENT = 'can_bot_send_inbox_to_accountant_when_uploaded_document',
  CAN_CONTINUE_ONBOARDING_FLOW = 'can_continue_onboarding_flow',
  CAN_CONTINUE_SELF_SERVE_ONBOARDING_FLOW_IN_FRENCH = 'can_continue_self_serve_onboarding_flow_in_french',
  CAN_CONTINUE_DIGITAL_VAULT_ONBOARDING_FLOW_IN_FRENCH = 'can_continue_digital_vault_onboarding_flow_in_french',
  CAN_CREATE_ESTIMATED_FINAL_TAXES = 'can_create_estimated_final_taxes',
  CAN_DISPLAY_PRIMARY_ESTATE_PROFESSIONAL_PHONE_NUMBER_ON_DASHBOARD_PAGE = 'can_display_primary_estate_professional_phone_number_on_dashboard_page',
  CAN_EXPORT_ACCOUNTING_REPORT = 'can_export_accounting_report',
  CAN_EXPORT_NEW_ACCOUNTING_REPORT = 'can_export_new_accounting_report',
  CAN_EXPORT_CALIFORNIA_DE_161_ATTACHMENTS = 'can_export_california_de_161_attachments',
  CAN_EXPORT_CLEAR_ESTATE_SUMMARY = 'can_export_clear_estate_summary',
  CAN_EXPORT_CLEAR_VAULT_SUMMARY = 'can_export_clear_vault_summary',
  CAN_FORCE_SHOW_CANADIAN_ESTATE_BANKING_ACCOUNT = 'can_force_show_canadian_estate_banking_account',
  CAN_GENERATE_ESTATE_AI_SUMMARY = 'can_generate_estate_ai_summary',
  CAN_INVITE_EXECUTOR = 'can_invite_executor',
  CAN_REGENERATE_WILL = 'can_regenerate_will',
  CAN_SEND_DOCUMENT_MAGIC_LINKS = 'can_send_document_magic_links',
  CAN_SEND_GUIDANCE_STEP_NOTIFICATION_IDLED_EXECUTOR_IN_NOTIFY_STAGE = 'can_send_guidance_step_notification_idled_executor_in_notify_stage',
  CAN_SEND_GUIDANCE_STEP_NOTIFICATION_IDLED_EXECUTOR_BETWEEN_PATH_AHEAD_AND_DISTRIBUTION_STAGE = 'can_send_guidance_step_notification_idled_executor_between_path_ahead_and_distribution_stage',
  CAN_SEND_NEWLY_ASSIGNED_CASE_MANAGER_ESTATE_EMAIL = 'can_send_newly_assigned_case_manager_estate_email',
  CAN_TRANSITION_CLEAR_VAULT_TO_CLEAR_WILL_ON_OVERVIEW = 'can_transition_clear_vault_to_clear_will_on_overview',
  CAN_TOGGLE_LANGUAGE = 'can_toggle_language',
  CAN_TOGGLE_DEVELOPER_MODE = 'can_toggle_developer_mode',
  CAN_USE_2022_ONTARIO_PROBATE_FORMS = 'can_use_2022_ontario_probate_forms',
  CAN_USE_CONTACT_SELECTOR_IN_STEPS = 'can_use_contact_selector_in_steps',
  CAN_USE_DOC_INGESTION = 'can_use_doc_ingestion',
  CAN_USE_DOCUMENT_AI = 'can_use_document_ai',
  CAN_USE_PAYWALL = 'can_use_paywall',
  CAN_USE_SUBMODULE_STEP_UI = 'can_use_submodule_step_ui',
  CAN_USE_WORKFLOW_TO_ASSIGN_EP = 'can_use_workflow_to_assign_ep',
  CAN_VIEW_AUTOMATED_QA_SELF_SERVE_BANNER = 'can_view_automated_qa_self_serve_banner',
  CAN_VIEW_CANADIAN_BEREAVEMENT_REGISTRY = 'can_view_canadian_bereavement_registry',
  CAN_VIEW_CLARA_UI = 'can_view_clara_ui',
  CAN_VIEW_CLEAR_VAULT_INTAKE_QUESTION_STEP = 'can_view_clear_vault_intake_question_step',
  CAN_VIEW_CLEAR_WILL_FINAL_VIDEO = 'can_view_clear_will_final_video',
  CAN_VIEW_ESTATE_PLAN_MEMO = 'can_view_estate_plan_memo',
  CAN_VIEW_IG_TAX_TAB = 'can_view_ig_tax_tab',
  CAN_VIEW_MARKETPLACE = 'can_view_marketplace',
  CAN_VIEW_REAL_ESTATE_TITLE_SEARCH_UPSELL = 'can_view_real_estate_title_search_upsell',
  CAN_VIEW_QA_SELF_SERVE_BANNER = 'can_view_qa_self_serve_banner',
  CAN_VIEW_CONTACTS_TOUR_GUIDE = 'can_view_contacts_tour_guide',
  CAN_VIEW_DOCUMENT_BUILDER_TOUR_GUIDE = 'can_view_document_builder_tour_guide',
  CAN_VIEW_DOCUMENTS_TOUR_GUIDE = 'can_view_documents_tour_guide',
  CAN_VIEW_FINANCIALS_TOUR_GUIDE = 'can_view_financials_tour_guide',
  CAN_VIEW_MEETINGS_TOUR_GUIDE = 'can_view_meetings_tour_guide',
  CAN_TOGGLE_LEGACY_INDIVIDUAL_COUPLES_ESSENTIAL_PLANS = 'can_toggle_legacy_individual_couples_essential_plans',
  CAN_ACCESS_VAULT_ONBOARDING_FLOW = 'can_access_vault_onboarding_flow',
  CAN_ACCESS_SETTLEMENT_ONBOARDING = 'can_access_settlement_onboarding',
  CAN_ACCESS_STANDARD_PLAN_WILL_REVIEW_MEETING = 'can_access_standard_plan_will_review_meeting',
  CAN_ACCESS_NEW_AGENTIC_WILL = 'can_access_new_agentic_will',
  CAN_ACCESS_NEW_EDITOR_WILL_REVIEW_STEPS_FLOW = 'can_access_new_editor_will_review_steps_flow',
  CAN_ACCESS_NEW_STEP_453513 = 'can_access_new_step453513',
  CAN_ACCESS_NEW_STEP_498617 = 'can_access_new_step498617',
  CAN_ACCESS_NEW_STEP_629473 = 'can_access_new_step629473',
  CAN_ACCESS_NEW_STEP_861054 = 'can_access_new_step861054',
  CAN_ACCESS_NEW_STEP_789042 = 'can_access_new_step789042',
  CAN_ACCESS_NEW_STEP_798133 = 'can_access_new_step798133',
  CAN_ACCESS_NEW_STEP_985756 = 'can_access_new_step985756',
  CAN_ACCESS_NEW_STEP_763323 = 'can_access_new_step763323',
  CAN_ACCESS_NEW_STEP_463422 = 'can_access_new_step463422',
  CAN_ACCESS_NEW_STEP_327781 = 'can_access_new_step327781',
  CAN_ACCESS_NEW_STEP_895621 = 'can_access_new_step895621',
  CAN_MIGRATE_GUIDED_PLAN = 'can_migrate_guided_plan',
  CAN_ACCESS_IN_APP_ANNOUNCEMENTS = 'can_access_in_app_announcements',
  CAN_ACCESS_ADVISOR_DOCUMENTS_TAB = 'can_access_advisor_documents_tab',
  CAN_ACCESS_ADVISOR_CLIENT_JOURNEY = 'can_access_advisor_client_journey',
  CAN_ACCESS_AI_RESEARCH = 'can_access_ai_research',
  CAN_ACCESS_STEP_210275 = 'can_access_step210275',
  CAN_ACCESS_STEP_447431 = 'can_access_step447431',
  CAN_ACCESS_STEP_983763 = 'can_access_step983763',
  CAN_ACCESS_CLARA_CONTENT_LIBRARY = 'can_access_clara_content_library',
  CAN_ACCESS_CLARA_FOR_ADVISORS = 'can_access_clara_for_advisors',
  CAN_ACCESS_YOUR_WILL_QC_STEP_V2 = 'can_access_your_will_qc_step_v2',
  CAN_VIEW_ADVISOR_PRO_UPSELLS = 'can_view_advisor_pro_upsells',
  CAN_VIEW_NEW_FINANCIAL_ADVISOR_DASHBOARD = 'can_view_new_financial_advisor_dashboard',
  CAN_ACCESS_REFERRAL_VAULT_PRE_FILLING = 'can_access_referral_vault_pre_filling',
  CAN_ACCESS_ANNUAL_REVIEW = 'can_access_annual_review',
  CAN_VIEW_LOGIN_PAGE_ENHANCEMENTS = 'can_view_login_page_enhancements',
  CAN_ACCESS_FAMILY_TREE = 'can_access_family_tree',
  CAN_VIEW_POA_PERSONAL_CARE_MAINTENANCE_WIDGET = 'can_view_poa_personal_care_maintenance_widget',
  CAN_VIEW_POA_PROPERTY_MAINTENANCE_WIDGET = 'can_view_poa_property_maintenance_widget',
  CAN_ACCESS_FIRST_NATIONS_DISCLAIMERS = 'can_access_first_nations_disclaimers',
  CAN_ADD_ADVISOR_QUESTIONS = 'can_add_advisor_questions',
  CAN_GENERATE_ESTATE_SNAPSHOT = 'can_generate_estate_snapshot',
  CAN_ACCESS_ESTATE_CLARA = 'can_access_estate_clara',
  CAN_ACCESS_ANNUAL_REVIEW_V2 = 'can_access_annual_review_v2',
  CAN_ACCESS_COUPLES_SPACE_CLEARDESK = 'can_access_couples_space_cleardesk',
  CAN_USE_EDITOR_AUTOSAVE = 'can_use_editor_autosave',
  COUPLES_AUTO_SYNC_ENABLED = 'couples_auto_sync_enabled',
  CAN_REGISTER_FOR_MEMOIR = 'can_register_for_memoir',
  CAN_VIEW_ROLE_CONFLICT_WARNING = 'can_view_role_conflict_warning',
  CAN_ACCESS_ADVISOR_FAMILY_TREE = 'can_access_advisor_family_tree',
  CAN_ACCESS_POA_EXTRACTION = 'can_access_poa_extraction',
  CAN_CONNECT_USER_TO_OUTLOOK = 'can_connect_user_to_outlook',
  CAN_ACCESS_NEW_ADVISOR_PRO_UPSELL_MODAL = 'can_access_new_advisor_pro_upsell_modal',
  CAN_ACCESS_CLAUSE_LIBRARY = 'can_access_clause_library',
  CAN_ACCESS_EMAIL_CHANGE = 'can_access_email_change',
  CAN_ACCESS_ADVISOR_BOOKING_LINK = 'can_access_advisor_booking_link',
  CAN_ACCESS_USER_LINKING = 'can_access_user_linking',
}
